// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".historial-tab .btn-see-more[data-v-60f5dbe6] {\n  width: 250px;\n}\n.historial-tab .historial-tab__pill[data-v-60f5dbe6] {\n  font-weight: normal;\n  color: #11291B;\n  font-size: 1rem;\n  padding: 0;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
